<div class="site-text">
    <p class="text">
        Sie möchten den Austausch elektronischer Rechnungen mit Ihren Geschäftspartnern verstärken? Im Verzeichnis eDirectory.ch finden Sie alle Unternehmen und Organisationen, die beim E-Invoicing mit einem Service Provider zusammenarbeiten, der bei eDirectory.ch teilnimmt.
    </p>
    <p class="text">
        eDirectory.ch unterstützt Sie dabei, in der Schweiz domizilierte Geschäftspartner zu identifizieren, die E-Rechnungen versenden und/oder empfangen wollen.
    </p>
    <p class="text">
        Das Verzeichnis des swissDIGIN-Forums wird von der PostFinance AG betrieben und trägt zu einer stärkeren Verbreitung des elektronischen Rechnungsaustauschs in der Schweiz bei.
    </p>
</div>